<div class="moorl-map">
    <div
        class="moorl-map-content"
        id="moorlMap"
        ref="moorlMap"
    ></div>
</div>